<template>
  <li>
    <span v-if="!editLive">{{ activity.title }}</span>
    <span v-if="editLive"><input :size="characters" v-on:keyup="keymonitor" class="editActivityName" type="text" ref="editName" v-model="activity.title" @blur="blurInput" /></span>
    <button class="subtleButton" @click="setActive(false)">Set Inactive</button>
    <button class="subtleButton" @click="editActivity()">Edit</button>
  </li>
</template>

<script>
import DataActivities from '@/data/controllers/DataActivities'
import {store} from '@/store'

export default {
  name: 'ActivityManage',
  props: ['id'],
  // props: ['activity'],
  data () {
    return {
      editLive: false
    }
  },
  computed: {
    characters () {
      if (this.activity.title.length > 2) {
        return this.activity.title.length - 2
      }
      return 1
    },

    activity () {
      return store.state.activities.active[this.id]
    }

  },
  methods: {
    setActive (active) {
      DataActivities.setActive(this.activity.id, active)
    },
    deleteActivity (activity) {
      let c = confirm('This will delete all record of this activity forever - there is no going back. Are you sure?')
      if (c) {
        DataActivities.deleteActivity(activity.id)
      }
    },
    editActivity () {
      this.editLive = true
      let $this = this
      this.$nextTick(function () {
        $this.$refs.editName.focus()
      })
    },
    blurInput () {
      this.editLive = false
      DataActivities.updateActivity(this.activity)
    },
    keymonitor (event) {
      if (event.key === 'Enter' || event.key === 'Escape') {
        this.blurInput()
      }
    }
  },
  beforeDestroy () {
    if (this.editLive) {
      this._blurInput()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/activities/ActivityManage.vue